import moment from "moment-timezone";
const appointmentState = {
  myappointmentCount: {},
  allappointmentCount: {},
  myappointment: [],
  myappointmentIsEMpty: true,
  allappointment: [],
  allappointmentIsEMpty: true,
  purpose: [],
  purposeIsEMpty: true,
  interval: {
    to: moment("2022-10-10T18:00:00").toDate(),
    from: moment("2022-10-10T09:00:00").toDate(),
  },
  intervalIsEMpty: true,
};
export const appointmentReducer = (state = appointmentState, action: any) => {
  switch (action.type) {
    case "SET_ALLAPPOINTMENTCOUNT":
      return {
        ...state,
        allappointmentCount: action.payload,
      };

    case "SET_MYAPPOINTMENTCOUNT":
      return {
        ...state,
        myappointmentCount: action.payload,
      };
    case "SET_ALLAPPOINTMENT":
      return {
        ...state,
        allappointment: action.payload.data,
        allappointmentIsEMpty: action.payload.empty,
      };
    case "SET_NEW_ALLAPPOINTMENT":
      return {
        ...state,
        allappointment: [
          { ...action.payload, status: "appointment" },
          ...state.allappointment,
        ],
      };

    case "SET_MYAPPOINTMENT":
      return {
        ...state,
        myappointment: action.payload.data,
        myappointmentIsEMpty: action.payload.empty,
      };
    case "SET_NEW_MYAPPOINTMENT":
      return {
        ...state,
        myappointment: [
          { ...action.payload, status: "appointment" },
          ...state.myappointment,
        ],
      };
    case "SET_ALLAPPOINTMENT_STATUS":
      const { appointmentid, status } = action.payload;
      const updatedAppointment = state.allappointment.map((item: any) => {
        if (appointmentid === item?._id) {
          return {
            ...item,
            status: status,
            new: true,
          };
        } else {
          return {
            ...item,
          };
        }
      });
      return {
        ...state,
        allappointment: updatedAppointment,
      };
    case "SET_MYAPPOINTMENT_STATUS":
      const updatedAppointments = state.allappointment.map((item: any) => {
        if (action.payload.appointmentid === item?._id) {
          return {
            ...item,
            status: action.payload.status,
            new: true,
          };
        } else {
          return {
            ...item,
          };
        }
      });
      return {
        ...state,
        allappointment: updatedAppointments,
      };
    case "SET_PURPOSE":
      return {
        ...state,
        purpose: action.payload.data,
        purposeIsEMpty: action.payload.empty,
      };
    case "SET_NEW_PURPOSE":
      return {
        ...state,
        purpose: [action.payload, ...state.purpose],
        purposeIsEMpty: action.payload.empty,
      };
    case "SET_TIMEINTERVAL":
      return {
        ...state,
        interval: action.payload.data,
        intervalIsEMpty: action.payload.empty,
      };
    default:
      return state;
  }
};
